/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Participant_Status_No_ShowInputs */



/**
* | output |
* | --- |
* | "No show" |
*
* @param {Tournaments_Lib_Participant_Status_No_ShowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_participant_status_no_show = /** @type {((inputs?: Tournaments_Lib_Participant_Status_No_ShowInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Participant_Status_No_ShowInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht erschienen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Absent")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("未到场")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("未出席")
	if (locale === "ko") return /** @type {LocalizedString} */ ("불참")
	return /** @type {LocalizedString} */ ("No show")
});